import { Form, Input, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { WardAsyncSelect } from '@/components/pos/WardAsyncSelect';
import { DeliveryDaysSelect } from './DeliveryDaysSelect';
import { FloatingField } from './FloatingField';
import { DateMaskInput } from './DateMaskInput';
import {
  citizenIdRules,
  customerBirthdayRules,
  customerEmailRules,
  deliveryDaysRules,
  requiredRule,
  isMaskedCccd,
} from './customerFormSchema';
import type { FulfillmentMode } from '@/pages/POS/types';

interface Props {
  form: import('antd').FormInstance;
  fulfillmentMode: FulfillmentMode;
  cityId?: string;
  cccdMasked?: boolean;
  onRevealCccd?: () => void;
}

export function DeliveryExtraFields({
  form,
  fulfillmentMode,
  cityId,
  cccdMasked,
  onRevealCccd,
}: Props) {
  const citizenIdVal = Form.useWatch('citizen_id', form);
  const isCccdMasked = cccdMasked || isMaskedCccd(citizenIdVal);

  const cccdSuffix =
    isCccdMasked && onRevealCccd ? (
      <Tooltip title="Nhấp để giải mã & sửa CCCD">
        <EyeOutlined style={{ cursor: 'pointer', color: '#1890ff' }} onClick={onRevealCccd} />
      </Tooltip>
    ) : undefined;

  return (
    <>
      <FloatingField label="Họ tên" name="customer_name" rules={[requiredRule('họ tên')]} required>
        <Input />
      </FloatingField>

      <FloatingField label="CCCD" name="citizen_id" rules={citizenIdRules} required>
        <Input maxLength={12} suffix={cccdSuffix} />
      </FloatingField>

      <FloatingField label="Quận / Huyện" name="customer_ward_id">
        <WardAsyncSelect
          cityId={cityId ?? ''}
          placeholder="Chọn phường / xã"
          onChange={(v) => form.setFieldValue('customer_ward_id', v)}
          onChangeWithLabel={(_, name) => form.setFieldValue('_wardName', name)}
        />
      </FloatingField>

      <FloatingField label="Email" name="customer_email" rules={customerEmailRules}>
        <Input />
      </FloatingField>

      <FloatingField label="Ngày sinh" name="customer_birthday" rules={customerBirthdayRules}>
        <DateMaskInput />
      </FloatingField>

      {fulfillmentMode === 'PREORDER' && (
        <Form.Item
          label="Hạn giao hàng"
          name="delivery_days"
          rules={deliveryDaysRules}
          className="compact-form-item"
        >
          <DeliveryDaysSelect />
        </Form.Item>
      )}

      <FloatingField label="Địa chỉ" name="customer_address">
        <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} />
      </FloatingField>

      <FloatingField label="Ghi chú" name="description">
        <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} />
      </FloatingField>
    </>
  );
}
